import type { MessageCatalog } from "../types";

export const ro = {
  language: {
    selectorLabel: "Limba"
  },
  brand: {
    homeLabel: "Pagina principală SOURCE / SAND"
  },
  nav: {
    primaryLabel: "Navigare principală",
    mobileLabel: "Navigare pe mobil",
    open: "Deschide navigarea",
    close: "Închide navigarea",
    water: "Apa",
    journey: "Drumul",
    journal: "Jurnal",
    join: "Înscrie-te la degustare"
  },
  metadata: {
    home: {
      title: "SOURCE / SAND — de la Borsec la Dubai",
      description:
        "Un test de piață independent în Dubai pentru un acces mai bun la apa minerală naturală Borsec din România."
    },
    journal: {
      title: "Apa, de la sursă. — SOURCE / SAND",
      description:
        "Note documentate despre apa minerală, proveniența românească, apa din Dubai și traseul practic al importului."
    },
    article: {
      title: "Notă despre apă — SOURCE / SAND",
      description:
        "O notă SOURCE / SAND documentată despre apă, gust, proveniență sau import."
    },
    research: {
      title: "Cercetare și praguri de decizie — SOURCE / SAND",
      description:
        "Surse, dovezi de piață, reguli pentru afirmații și praguri de decizie pentru testul Borsec–Dubai."
    },
    privacy: {
      title: "Confidențialitate — SOURCE / SAND",
      description:
        "Cum gestionează SOURCE / SAND răspunsurile la testul de piață și consimțământul pentru e-mail."
    },
    notFound: {
      title: "Pagina nu a fost găsită — SOURCE / SAND",
      description:
        "Un test de piață independent în Dubai pentru un acces mai bun la apa minerală naturală Borsec din România."
    }
  },
  dates: {
    unavailable: "Data nu este disponibilă",
    lastUpdated: "Ultima actualizare"
  },
  hero: {
    title: "Apă minerală adevărată, din Carpați până în Dubai.",
    lede:
      "Testăm dacă Dubaiul își dorește acces mai simplu și mai sigur la Borsec—apa minerală naturală din România—în ambalajele și la prețurile pe care oamenii chiar le-ar alege.",
    primaryAction: "Aș bea asta",
    secondaryAction: "Vezi ce conține apa",
    imageAlt:
      "Vizualizare de produs cu o sticlă rece de Borsec între un pârâu din Carpați și dune deșertice",
    imageCaption: "Vizualizare de produs pentru cercetarea de piață",
    independent: "Test de piață independent",
    disclosure: "Fără afiliere sau susținere din partea Borsec ori Romaqua Group"
  },
  water: {
    introTitle: "Apă cu un loc al ei în lume.",
    introBody:
      "Apa municipală din Dubai este desalinizată și tratată conform unor standarde stricte pentru apa potabilă. Apa minerală naturală este o propunere diferită: mineralele dizolvate și caracterul ei provin dintr-o sursă subterană identificată.",
    desalinationFactLabel: "Date despre desalinizarea din Dubai",
    statUnit: "milioane de galoane imperiale pe zi",
    statBody: "Capacitatea instalată de desalinizare a Dubaiului în 2025.",
    dewaReport: "Raportul de sustenabilitate DEWA 2025",
    dubaiPathTitle: "Apa din Dubai",
    dubaiPath: ["Mare", "Desalinizare", "Tratare", "Rețea"],
    borsecPathTitle: "Apa minerală Borsec",
    borsecPath: ["Ploaie și zăpadă", "Rocă din Carpați", "Sursă subterană", "Îmbuteliere la sursă"],
    originNote:
      "Este o alegere de gust și proveniență, nu o afirmație că alimentarea Dubaiului ar fi nesigură. DEWA spune că apa sa potabilă respectă cerințele actuale ale Organizației Mondiale a Sănătății.",
    mineralsTitle: "Citește eticheta, nu exagerările.",
    mineralsBody:
      "O fișă tehnică din 2024 pentru Borsec carbogazoasă natural prezintă profilul de mai jos. Valorile exacte depind de sursă și de produs; eticheta înregistrată în EAU trebuie să fie referința finală.",
    mineralAnalysisLabel: "Analiza minerală Borsec",
    mineralLabels: {
      Bicarbonate: "Bicarbonat",
      Calcium: "Calciu",
      Magnesium: "Magneziu",
      Sodium: "Sodiu"
    },
    sourceNote:
      "Fișa tehnică Borsec carbogazoasă natural, revizuită la 8 aprilie 2024. Compoziția trebuie reverificată pentru produsul exact aprobat în EAU.",
    sourceLink: "Citește informațiile despre sursa Borsec",
    imageAlt: "Un pahar cu apă minerală carbogazoasă pe o piatră udă, lângă un pârâu"
  },
  journey: {
    title: "O singură sursă. Un drum lung până la frigiderul tău.",
    body:
      "Un transport ar putea pleca din Borsec, traversa Europa până la port, trece prin ruta Suez și ajunge în Jebel Ali. Înainte să mișcăm un singur palet, vrem să știm ce ar cumpăra cu adevărat Dubaiul.",
    mapLabel: "Rută ilustrativă de la Borsec la Dubai",
    mapTitle: "Rută ilustrativă de la Borsec prin Constanța și Suez până la Jebel Ali",
    stops: [
      { name: "Borsec", detail: "Harghita, România" },
      { name: "Constanța", detail: "Port ilustrativ" },
      { name: "Suez", detail: "Rută maritimă" },
      { name: "Jebel Ali", detail: "Dubai, EAU" }
    ],
    routeNote: "Rută ilustrativă · logistica finală și porturile nu sunt încă stabilite",
    signalCount: "4 semnale",
    signalSummary: "Ambalaj, preț, interes pentru degustare și intenție de repetare.",
    demandTitle: "Traseul este posibil. Cererea trebuie încă demonstrată.",
    demandBody:
      "Înainte de a transporta un palet, testul trebuie să arate ce ar comanda oamenii, ce ambalaje preferă, ce preț livrat pare credibil și dacă interesul s-ar transforma într-un obicei repetat.",
    addSignal: "Adaugă semnalul tău",
    sourceNote: "Cercetare independentă a cererii · fără comenzi sau plată"
  },
  validation: {
    title: "Ajută-ne să conturăm o modalitate mai bună de cumpărare.",
    lede:
      "Spune-ne ce ai comanda cu adevărat. Fără plată și fără spam—doar un semnal mai clar decât un like.",
    measuresTitle: "Ce vom măsura",
    measures: ["Interes calificat", "Acceptarea prețului", "Ambalajul preferat", "Intenția de repetare"],
    usefulSignalTitle: "Ce înseamnă un semnal util?",
    usefulSignalBody:
      "Un răspuns real la preț, o cerere de degustare și intenția de repetare contează mai mult decât creșterea unui newsletter. Consumatorii actuali de Borsec și cumpărătorii aflați la prima încercare vor fi măsurați separat."
  },
  interestForm: {
    legends: {
      buyer: "Cumpăr pentru",
      familiarity: "Eu și Borsec",
      water: "Borsec preferată",
      format: "Ambalaj preferat",
      priceBefore: "Ai precomanda un bax de ",
      priceBetween: " la ",
      priceAfter: "?",
      frequency: "Cât de des s-ar potrivi?"
    },
    options: {
      buyer: [
        { value: "home", label: "Acasă" },
        { value: "office", label: "Birou" },
        { value: "hospitality", label: "Restaurant / hotel" },
        { value: "retail", label: "Comerț cu amănuntul" }
      ],
      familiarity: [
        { value: "regular", label: "O cumpăr deja" },
        { value: "tried", label: "Am încercat-o" },
        { value: "aware", label: "Cunosc numele" },
        { value: "new", label: "Este nouă pentru mine" }
      ],
      water: [
        { value: "sparkling", label: "Carbogazoasă" },
        { value: "still", label: "Plată" },
        { value: "both", label: "Ambele" }
      ],
      format: [
        { value: "glass", label: "Sticlă" },
        { value: "pet", label: "PET" },
        { value: "either", label: "Oricare" }
      ],
      price: [
        { value: "yes", label: "Da" },
        { value: "maybe", label: "Poate" },
        { value: "no", label: "Nu la prețul acesta" }
      ],
      frequency: [
        { value: "weekly", label: "Săptămânal" },
        { value: "monthly", label: "Lunar" },
        { value: "occasionally", label: "Ocazional" },
        { value: "tasting", label: "Întâi o degust" }
      ]
    },
    priceQualifier:
      "Test ipotetic de preț pentru livrare directă. Ambalajul, costul final și disponibilitatea nu sunt încă confirmate.",
    email: "E-mail",
    emailPlaceholder: "nume@example.com",
    area: "Zona din Dubai",
    optional: "opțional",
    areaPlaceholder: "de ex. Marina",
    contactConsent:
      "Trimite-mi e-mail despre degustări, disponibilitate și acest test de piață.",
    marketingConsent:
      "Trimite-mi și note SOURCE / SAND despre apă, din când în când. Opțional.",
    saving: "Salvăm semnalul tău…",
    submit: "Înscrie-te la degustare",
    footnote: "Test de piață independent · astăzi nu se preiau comenzi sau plăți.",
    successTitle: "Ești pe lista de degustare.",
    successBody:
      "Îți mulțumim. Vom folosi răspunsul despre ambalaj și preț pentru a evalua dacă un proiect-pilot real are sens și îți vom scrie doar în limitele permisiunilor alese.",
    successAction: "Citește notele despre apă",
    errors: {
      verificationExpired: "Verificarea a expirat. Te rugăm să o completezi din nou.",
      verificationLoad:
        "Verificarea nu s-a putut încărca. Verifică conexiunea și încearcă din nou.",
      verificationMisconfigured:
        "Formularul de interes este temporar indisponibil cât timp configurăm verificarea.",
      emailRequired:
        "Adaugă adresa de e-mail ca să te putem contacta despre acest test de piață.",
      emailInvalid: "Introdu o adresă de e-mail validă și încearcă din nou.",
      consentRequired:
        "Confirmă că te putem contacta în legătură cu acest test de piață.",
      verificationRequired: "Completează verificarea și încearcă din nou.",
      verificationFailed: "Verificarea a eșuat. Reîncarcă pagina și încearcă din nou.",
      saveFailed: "Răspunsul nu a putut fi salvat. Încearcă din nou peste puțin timp.",
      network:
        "Serviciul testului de piață nu a putut fi contactat. Verifică conexiunea și încearcă din nou.",
      invalidRequest:
        "Unele detalii din formular nu au fost acceptate. Verifică-le și încearcă din nou.",
      conflict:
        "Acest răspuns s-a modificat după trimitere. Reîncarcă pagina și încearcă din nou."
    }
  },
  faq: {
    title: "Răspunsuri clare.",
    items: [
      {
        question: "Ce se întâmplă dacă sunt interesați suficient de mulți oameni?",
        answer:
          "Vom folosi semnalul pentru a decide dacă mergem mai departe cu degustări, discuții cu furnizorii, verificările de import și un proiect-pilot conform. Nu se preiau comenzi sau plăți."
      },
      {
        question: "Sunteți afiliați cu Borsec?",
        answer:
          "Nu. SOURCE / SAND este un proiect independent de validare a pieței și nu are astăzi un acord de distribuție."
      },
      {
        question: "Preluați comenzi?",
        answer:
          "Nu încă. Colectăm interes calificat și cereri de degustare înaintea oricărui pas comercial."
      },
      {
        question: "Apa din Dubai este nesigură?",
        answer:
          "Nu. DEWA raportează că apa sa potabilă respectă cerințele actuale ale Organizației Mondiale a Sănătății. Proiectul acesta este despre gust și proveniența sursei."
      }
    ]
  },
  finalCta: {
    title: "I-ai face loc în frigider?",
    body:
      "Acordă-ne două minute. Alegerile tale privind ambalajul, prețul și intenția de cumpărare vor decide dacă proiectul merge mai departe.",
    join: "Înscrie-te la degustare",
    trade: "Sunt cumpărător comercial"
  },
  footer: {
    navigationLabel: "Navigare în subsol",
    research: "Cercetare",
    journal: "Jurnal",
    privacy: "Confidențialitate",
    contact: "Contact",
    disclosure:
      "Test de piață independent · Fără afiliere sau susținere din partea Borsec ori Romaqua Group.",
    location: "Dubai, EAU"
  },
  research: {
    title: "Ce ar face proiectul real?",
    intro:
      "Nu traficul. Nu complimentele. Ci o combinație credibilă de preferință de gust, acceptare a prețului, intenție de repetare, aprovizionare conformă și economie viabilă.",
    hypothesisLabel: "Ipoteză de lucru",
    hypothesisBody:
      "Dubaiul ar putea susține o ofertă Borsec axată pe proveniență, începând cu diaspora, livrarea premium la domiciliu și ospitalitatea.",
    gatesTitle: "Praguri de decizie stabilite în avans",
    gatesBody:
      "Acestea sunt praguri de proiect, nu repere externe ale industriei. Stabilirea lor înainte de campanie împiedică transformarea unei liste de așteptare flatante într-un argument de afaceri.",
    metrics: [
      {
        value: "1,000",
        label: "sesiuni calificate din EAU",
        note: "acoperire suficientă pentru a separa un tipar real de traficul prietenilor și familiei"
      },
      {
        value: "150+",
        label: "răspunsuri complete",
        note: "cu raportare separată pentru consumatorii actuali de Borsec și cumpărătorii aflați la prima încercare"
      },
      {
        value: "3%",
        label: "conversie cu intenție ridicată",
        note: "cerere de degustare sau rezervare la un preț afișat viabil, nu doar un e-mail"
      },
      {
        value: "3",
        label: "proiecte-pilot B2B în scris",
        note: "cu calendar, ambalaj și volum lunar estimat"
      }
    ],
    testTitle: "Ce vom testa",
    tests: [
      {
        title: "Gust și proveniență",
        body: "Poate Borsec câștiga preferința fără afirmații alarmiste despre apa locală?"
      },
      {
        title: "Ambalaje reale",
        body: "Plată sau carbogazoasă, sticlă sau PET, bax pentru acasă sau sticlă pentru ospitalitate."
      },
      {
        title: "Un preț viabil",
        body:
          "Se angajează oamenii atunci când întrebarea include un preț plauzibil pentru baxul livrat?"
      },
      {
        title: "Comportament repetat",
        body: "Este doar nostalgie și curiozitate sau un obicei săptămânal ori lunar?"
      }
    ],
    guardrailsTitle: "Ce nu vom afirma",
    guardrails: [
      "Fără formulări despre siguranță, puritate sau hidratare superioară.",
      "Fără afirmații medicale, despre digestie, detoxifiere sau boli.",
      "Fără a sugera că apa municipală din Dubai ar fi nesigură.",
      "Fără afirmații de tipul „primul din EAU” sau raritate artificială.",
      "Fără afirmații privind autorizarea sau distribuția dacă nu există un acord.",
      "Fără aureolă de sustenabilitate în lipsa unor dovezi măsurate despre transport și ambalaj."
    ],
    sourcesTitle: "Biblioteca de surse",
    sourcesBody:
      "Afirmațiile de pe acest site sunt intenționat restrânse și legate, ori de câte ori este posibil, de surse primare sau autoritare actuale.",
    sources: [
      {
        label: "Lista UE a apelor minerale naturale recunoscute, iunie 2026",
        href: "https://food.ec.europa.eu/document/download/ec4fbcc0-7185-4dce-820a-27f7e2653dad_en?filename=labelling-nutrition_mineral-waters_list_eu-recognised.pdf"
      },
      {
        label: "Romaqua Group: istoria și proveniența Borsec",
        href: "https://romaqua-group.ro/en/brands/borsec/"
      },
      {
        label: "Raportul de sustenabilitate DEWA 2025",
        href: "https://www.dewa.gov.ae/-/media/Files/Sustainability/Sustainability_Report_English_2025.ashx"
      },
      {
        label: "Serviciile alimentare ale Municipalității Dubai",
        href: "https://www.dm.gov.ae/dubai-municipality-services/"
      },
      {
        label: "Studiul din 2022 privind consumatorii de apă îmbuteliată din EAU",
        href: "https://www.mdpi.com/2071-1050/14/5/2664"
      }
    ]
  },
  privacy: {
    title: "Confidențialitatea, pe înțelesul tuturor.",
    lede:
      "SOURCE / SAND este un proiect independent de cercetare a pieței. Colectăm doar ce este necesar pentru a înțelege cererea și, dacă ne soliciți, pentru a te contacta despre degustări sau disponibilitate.",
    collectTitle: "Ce colectăm",
    collectBody:
      "E-mailul tău, zona generală din Dubai, preferințele de apă și ambalaj, răspunsul la un preț afișat, frecvența intenționată de cumpărare, tipul de cumpărător, familiaritatea cu Borsec, opțiunile de consimțământ și atribuirea de bază a campaniei. Nu cerem adresa exactă de acasă, naționalitatea, informații medicale, date de plată sau acte de identitate.",
    useTitle: "De ce le folosim",
    useBody:
      "Pentru a măsura interesul calificat, a invita respondenții care au acceptat la degustări, a înțelege preferințele de preț și ambalaj și a decide dacă merită urmărit un proiect-pilot de aprovizionare conform. Permisiunea opțională pentru jurnal este separată de permisiunea pentru contactul de cercetare.",
    storageTitle: "Stocare și acces",
    storageBody:
      "Răspunsurile sunt stocate într-o bază de date Cloudflare D1. E-mailul de notificare a potențialilor clienți este trimis doar către căsuța verificată a proiectului. Adresele IP brute nu sunt stocate. Țara și codul centrului de date Cloudflare pot fi păstrate pentru verificări generale ale calității traficului.",
    retentionTitle: "Păstrarea datelor și opțiunile tale",
    retentionBody:
      "Răspunsurile la cercetare sunt păstrate până la 12 luni, cu excepția cazului în care există o nevoie legitimă de a păstra un agregat anonimizat. Poți solicita accesul, corectarea sau ștergerea răspunsului ori oprirea oricărui e-mail viitor scriind la",
    statusTitle: "Statut independent",
    statusBody:
      "Acest proiect nu este afiliat cu și nu este susținut de Borsec sau Romaqua Group. Dacă un partener comercial preia proiectul, această informare va fi actualizată înainte ca datele să fie folosite într-un scop semnificativ diferit."
  },
  notFound: {
    eyebrow: "404 · În afara traseului",
    title: "Pagina aceasta s-a evaporat.",
    body: "Încearcă testul de piață, notele de cercetare sau jurnalul.",
    back: "Înapoi la SOURCE / SAND"
  },
  blog: {
    common: {
      minuteShort: "min",
      minutes: (count) =>
        `${count.toLocaleString("ro-RO")} ${count === 1 ? "minut" : "minute"}`,
      readNote: "Citește nota"
    },
    preview: {
      title: "Note despre apă, fără ceața wellness.",
      intro:
        "Lecturi scurte și documentate despre apa minerală, gust, sistemul de apă al Dubaiului și drumul practic de la interes la import.",
      readAll: "Citește toate notele",
      empty: "Nu există încă note publicate despre apă.",
      unavailable: "Notele traduse sunt temporar indisponibile."
    },
    index: {
      title: "Apa, de la sursă.",
      intro:
        "Etichete minerale, surse românești, sistemul de apă din Dubai, realitățile importului și gust—scrise cu surse și fără teatru medical.",
      ruleLabel: "Regula editorială 01",
      ruleBody: "O întrebare de căutare. O obiecție a cumpărătorului. O acțiune următoare sinceră.",
      read: "Citește"
    },
    article: {
      allNotes: "Toate notele",
      sourcesTitle: "Surse",
      sourcesIntro: "Referințele principale folosite pentru această notă. Ultima verificare",
      notFoundEyebrow: "404 · Notă lipsă",
      notFoundTitle: "Nota aceasta despre apă nu a fost găsită.",
      notFoundBody: "Adresa poate fi veche sau schița poate să nu fi fost publicată.",
      backToJournal: "Înapoi la jurnal",
      outageEyebrow: "Conexiune întreruptă",
      outageTitle: "Nota este temporar inaccesibilă.",
      outageBody:
        "Verifică conexiunea și încearcă din nou. Acesta nu este un rezultat permanent de tip „negăsit”.",
      tryAgain: "Încearcă din nou",
      loading: "Se încarcă nota despre apă…",
      visualsLabel: "Imaginea articolului"
    },
    categories: {
      "Mineral water": "Apă minerală",
      "Dubai water": "Apa din Dubai",
      "Import diary": "Jurnal de import",
      "Market case study": "Studiu de caz al pieței"
    }
  }
} satisfies MessageCatalog;
